import trustpilot1 from '../assets/icons/trust-pilot.svg';
import trustpilot2 from '../assets/icons/trustpilotstarsfr.svg';

export default function Home(){
    return(
        <>
        <section className="home-section relative overflow-hidden" id="home">
            <div className="main-content w-[95%] md:w-[85%] m-auto pt-8 sm:pt-10 lg:pt-10 pb-8 relative z-10">

                <div className="bg-gradient-to-tr from-[#0a1a5f] via-[#002f9c] to-[#0d47ff] rounded-3xl p-4 sm:p-8 lg:p-12 shadow-2xl relative overflow-hidden">
                    
                    <div className="absolute top-0 right-0 w-96 h-96 bg-white opacity-5 rounded-full -translate-y-48 translate-x-48"></div>
                    <div className="absolute bottom-0 left-0 w-64 h-64 bg-white opacity-5 rounded-full translate-y-32 -translate-x-32"></div>
                    
                    <div className="relative z-10">

                        {/* Trustpilot Rating */}
                        <div className="flex-row items-start gap-2 mb-6">
                            <img src={trustpilot1} alt="Trustpilot Rating" className='w-[115px]' />
                            <img src={trustpilot2} alt="Trustpilot Rating" className='w-[205px] mt-3' />
                        </div>

                        {/* Activation Badge */}
                        <div className="inline-flex items-center space-x-2 bg-black bg-opacity-30 backdrop-blur-sm px-4 py-2 rounded-full mb-8 border border-white border-opacity-20">
                            <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd"/>
                            </svg>
                            <span className="text-white font-medium">Ativação Imediata</span>
                        </div>

                        {/* Main Headline */}
                        <div className="mb-6">
                            <h1 className="text-3xl xs:text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-3">
                                <span>Bem-vindo ao </span>
                                <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-400">
                                  TVPortugal4k
                                </span>
                                <span className="block">O Melhor IPTV da</span>
                                <span className="block">Portugal 🇵🇹 </span>
                            </h1>

                            <h2 className="text-lg sm:text-xl font-bold text-white mb-6">
                                Qualidade e Extras para o teu Entretenimento!
                            </h2>
                        </div>

                        {/* Service Description */}
                        <div className="mb-8">
                            <p className="text-sm sm:text-base text-white leading-relaxed max-w-4xl">
                            Desfruta de IPTV com qualidade impressionante em 4K / Full HD 
                                <span className="font-bold text-yellow-300"> 4K / Full HD</span> 
                                em qualquer dispositivo, em qualquer lugar. 
                                Acesso a <span className="font-bold text-yellow-300">95.000+ canais</span> 
                                e <span className="font-bold text-yellow-300">249.000+ filmes e séries (VOD)</span> 
                                com <span className="font-bold text-yellow-300">100% de uptime</span>. 
                                Ativação gratuita do IBO Pro Player 🎁 e início imediato – sem custos ocultos.
                            </p>
                        </div>

                        {/* CTA Button */}
                        <div className="flex flex-col sm:flex-row gap-4">
                            <button 
                                onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}
                                className="bg-white hover:bg-gray-100 text-gray-900 px-6 py-3 rounded-xl font-bold text-base transition-all duration-300 flex items-center justify-center space-x-2 shadow-2xl hover:shadow-3xl transform hover:scale-105"
                            >
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3z"/>
                                </svg>
                                <span>VER PREÇOS</span>
                            </button>
                        </div>
                    </div>
                </div>

                {/* Feature Cards */}
                <div className="mt-20 relative px-3 md:px-0">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">

                        {/* Card 1 */}
                        <div className="bg-white border border-gray-100 rounded-2xl p-5 shadow-lg">
                            <div className="flex flex-col items-center text-center space-y-6">
                                <h3 className="text-lg md:text-xl font-bold text-blue-900">
                                    Mais de 79.000 canais de todo o mundo
                                </h3>
                                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                                    Uma lista completa com todos os canais europeus disponíveis. 
                                    Com mais de 79.000 canais de televisão, oferecemos uma das listas mais completas do mercado.
                                </p>
                            </div>
                        </div>

                        {/* Card 2 */}
                        <div className="bg-white border border-gray-100 rounded-2xl p-5 shadow-lg">
                            <div className="flex flex-col items-center text-center space-y-6">
                                <h3 className="text-lg md:text-xl font-bold text-blue-900">    
                                    Ligação ultra-rápida
                                </h3>
                                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                                    Ao contrário de outros fornecedores IPTV, utilizamos servidores europeus dedicados de alta qualidade. 
                                    A abertura dos canais de TV demora menos de 0,5 segundos.
                                </p>
                            </div>
                        </div>

                        {/* Card 3 */}
                        <div className="bg-white border border-gray-100 rounded-2xl p-5 shadow-lg">
                            <div className="flex flex-col items-center text-center space-y-6">
                                <h3 className="text-lg md:text-xl font-bold text-blue-900">
                                    Instalação instantânea
                                </h3>
                                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                                    Podes configurar e instalar facilmente a tua subscrição IPTV em qualquer dispositivo. 
                                    Facilitamos o processo com instalação remota e ativação gratuita do IBO Pro Player.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </section>
        </>
    )
}